import React from "react";

const BulletPointIcon = ({ width, height, fill }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 10 10" fill="none">
      <circle cx="5" cy="5" r="5" fill={fill} />
    </svg>
  );
};

BulletPointIcon.defaultProps = {
  width: 10,
  height: 10,
  fill: "black",
};

export default BulletPointIcon;
